import { render, staticRenderFns } from "./TimelinePhase2.vue?vue&type=template&id=5be0f308&scoped=true"
import script from "./TimelinePhase2.vue?vue&type=script&lang=js"
export * from "./TimelinePhase2.vue?vue&type=script&lang=js"
import style0 from "./TimelinePhase2.vue?vue&type=style&index=0&id=5be0f308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be0f308",
  null
  
)

export default component.exports